export const partnerApiPaths = {
  LIST: getV1Path("partner/management/list-partner"),
  DETAIL: getV1Path("partner/management/detail-partner"),
  UPDATE: getV1Path("partner/management/update-partner"),
  CREATE: getV1Path("partner/management/create-partner"),
  DELETE: getV1Path("partner/management/delete-partner"),
};

export const storageApiPaths = {
  LIST: getV1Path("storage/management/list-storage"),
  DETAIL: getV1Path("storage/management/detail-storage"),
  CREATE: getV1Path("storage/management/create-storage"),
  UPDATE: getV1Path("storage/management/update-storage"),
  DELETE: getV1Path("storage/management/delete-storage"),
};

export const inventoryPaths = {
  LIST: getV1Path("inventory/management/list-inventory"),
  DETAIL: getV1Path("inventory/management/detail-inventory"),
  CREATE: getV1Path("inventory/management/create-inventory"),
  UPDATE: getV1Path("inventory/management/update-inventory"),
  DELETE: getV1Path("inventory/management/delete-inventory"),
  EXPORT: getV1Path("inventory/export-inventory"),
};

export const categoryPaths = {
  LIST: getV1Path("category/management/list-category"),
  DETAIL: getV1Path("category/management/detail-category"),
  CREATE: getV1Path("category/management/create-category"),
  UPDATE: getV1Path("category/management/update-category"),
  DELETE: getV1Path("category/management/delete-category"),
};

export const goodsPaths = {
  LIST: getV1Path("goods/management/list-goods"),
  DETAIL: getV1Path("goods/management/detail-goods"),
  CREATE: getV1Path("goods/management/create-goods"),
  UPDATE: getV1Path("goods/management/update-goods"),
  DELETE: getV1Path("goods/management/delete-goods"),
};

export const variantPaths = {
  LIST: getV1Path("variant/management/list-variant"),
  DETAIL: getV1Path("variant/management/detail-variant"),
  CREATE: getV1Path("variant/management/create-variant"),
  UPDATE: getV1Path("variant/management/update-variant"),
  DELETE: getV1Path("variant/management/delete-variant"),
};

export const transactionHistoryPaths = {
  LIST: getV1Path("transaction/management/list-transaction"),
  DETAIL: getV1Path("transaction/management/detail-transaction"),
  STATISTICAL: getV1Path(
    "transaction/management/statistical/statistical-transaction"
  ),
  MSALE_IMPORT: getV1Path("storage/sim/ecommerce/import-msale")
};

export const importPaths = {
  REQUESTORDER: getV1Path(
    "storage/datacode/supplier/mobifone/request-to-export-data-code-card"
  ),
  AVTIVEORDER: getV1Path("storage/datacode/active-order-data-code-card"),
  IMPORT: getV1Path("storage/datacode/import-data-code-card"),
  STRAIGHTIMPORT: getV1Path("storage/datacode/straight-import-data-code-card"),
  EXPORT_TEMPLATE: getV1Path("storage/export-template"),
  IMPORT_SIM_COMBO: getV1Path("storage/sim/import-sim-combo"),
  SERIAL_IMPORT: getV1Path("storage/sim/ecommerce/import-serial"),
  PHONE_NUMBER_IMPORT: getV1Path("storage/sim/ecommerce/import-phone-number"),
};

export const fieldPaths = {
  LIST: getV1Path("field/management/list-field"),
  DETAIL: getV1Path("field/management/detail-field"),
  CREATE: getV1Path("field/management/create-field"),
  UPDATE: getV1Path("field/management/update-field"),
  DELETE: getV1Path("field/management/delete-field"),
};

export const customerProfilePaths = {
  LIST: getV1Path("customerprofile/management/list-customer-profile"),
  DETAIL: getV1Path("customerprofile/management/detail-customer-profile"),
  CREATE: getV1Path("customerprofile/management/create-customer-profile"),
  UPDATE: getV1Path("customerprofile/management/update-customer-profile"),
  DELETE: getV1Path("customerprofile/management/delete-customer-profile"),
};

export const walletPaths = {
  LIST: getV1Path("wallet/management/list-wallet"),
  DETAIL: getV1Path("wallet/management/detail-wallet"),
  CREATE: getV1Path("wallet/management/create-wallet"),
  UPDATE: getV1Path("wallet/management/update-wallet"),
  DELETE: getV1Path("wallet/management/delete-wallet"),
};

export const itemPaths = {
  LIST: getV1Path("item/management/list-item"),
  DETAIL: getV1Path("item/management/detail-item"),
  REPORT: getV1Path("item/management/report/report-item"),
};

export const userPaths = {
  LIST: getV1Path("user/management/list-user"),
  DETAIL: getV1Path("user/management/detail-user"),
  FEATURE: getV1Path("user/list-feature-user"),
  UPDATE: getV1Path("user/management/update-user"),
  CREATE: getV1Path("user/signup"),
  ROLE: getV1Path("role/management/list-role"),
  DELETE: getV1Path("user/management/delete-user"),
  CHANGE_PASSWORD: getV1Path("user/change-password"),
};

export const reportPaths = {
  EXPORT: getV1Path("storage/export-item"),
  EXPORT_DESTROY: getV1Path("storage/export-destroy-item"),
  TRANSFER: getV1Path("storage/transfer-item"),
  STATISTICAL: getV1Path(
    "transaction/management/report/report-statistical-transaction"
  ),
  TRANSACTION: getV1Path("transaction/management/report/report-transaction"),
};

export const configuationPaths = {
  LIST: getV1Path("configuration/management/list-configuration"),
  CREATE: getV1Path("configuration/management/create-configuration"),
  UPDATE: getV1Path("configuration/management/update-configuration"),
};

export const errorCodePaths = {
  LIST: getV1Path("errorcode/management/list-error-code"),
  UPDATE: getV1Path("errorcode/management/update-error-code"),
  CREATE: getV1Path("errorcode/management/create-error-code"),
  DELETE: getV1Path("errorcode/management/delete-error-code"),
};

export const rolePaths = {
  LIST: getV1Path("role/management/list-role"),
  UPDATE: getV1Path("role/management/update-role"),
  CREATE: getV1Path("role/management/create-role"),
  DETAIL: getV1Path("role/management/detail-role"),
  DELETE: getV1Path("role/management/delete-role"),
};

export const permissionPaths = {
  LIST: getV1Path("user/permission/list-permission"),
  UPDATE: getV1Path("user/permission/update-permission"),
  CREATE: getV1Path("user/permission/create-permission"),
  DELETE: getV1Path("user/permission/delete-permission"),
};

export const featurePaths = {
  LIST: getV1Path("feature/management/list-feature"),
  UPDATE: getV1Path("feature/management/update-feature"),
  CREATE: getV1Path("feature/management/create-feature"),
  DETAIL: getV1Path("feature/management/detail-feature"),
  DELETE: getV1Path("feature/management/delete-feature"),
};

export const actionLogPaths = {
  LIST: getV1Path("actionlog/management/list-action-log"),
  DETAIL: getV1Path("actionlog/management/detail-action-log"),
};

export const balanceTicketPaths = {
  LIST: getV1Path("balanceticket/management/list-balance-ticket"),
  DETAIL: getV1Path("balanceticket/management/detail-balance-ticket"),
  CREATE_TICKET: getV1Path("balanceticket/create-ticket"),
  APPROVE_TICKET: getV1Path("balanceticket/approve-ticket"),
};

export const supplierFeaturePaths = {
  CHECK_LIST_PACKAGE: getV1Path(
    "storage/datacode/supplier/mobifone/check-list-package"
  ),
  CHECK_TRANSACTION: getV1Path(
    "storage/datacode/supplier/mobifone/check-transaction"
  ),
  CHECK_ORDER_BALANCE: getV1Path(
    "storage/datacode/supplier/mobifone/check-order-balance"
  ),
  CHECK_REGISTRATION_CONDITION: getV1Path(
    "storage/datacode/supplier/mobifone/check-registration-conditions-package"
  ),
  BRICK_DATA_CODE: getV1Path(
    "storage/datacode/supplier/mobifone/brick-data-code-card"
  ),
  CHECK_DATA_CODE_CARD: getV1Path(
    "storage/datacode/supplier/vmg/check-data-code-card"
  ),
};

export const filePaths = {
  LIST: getV1Path("file/management/list-file"),
  DESTROY: getV1Path("file/management/destroy-file"),
};

export const deliveryServicePaths = {
  LIST: getV1Path("deliveryservice/management/list-delivery-service"),
  UPDATE: getV1Path("deliveryservice/management/update-delivery-service"),
  CREATE: getV1Path("deliveryservice/management/create-delivery-service"),
  DETAIL: getV1Path("deliveryservice/management/detail-delivery-service"),
  DELETE: getV1Path("deliveryservice/management/delete-delivery-service"),
};

export const partnerKeyPaths = {
  LIST: getV1Path("partner/key/management/list-partner-key"),
  UPDATE: getV1Path("partner/key/management/update-partner-key"),
  CREATE: getV1Path("partner/key/management/create-partner-key"),
  DETAIL: getV1Path("partner/key/management/detail-partner-key"),
  DELETE: getV1Path("partner/key/management/delete-partner-key"),
};

export const temporaryPaths = {
  TRANSACTION_WAREHOUSE: getV1Path("temporary/get-transaction-warehouse"),
};

export const authenticationPaths = {
  LOGIN: getV1Path("user/login"),
};

function getV1Path(path: String) {
  return `https://apicms.neci.vn/api/v1/${path}`;
}
